import momentPtBr from '@/config/i18n/moment-pt_BR'

export default momentPtBr
